export default function validateCardholderName(cardholderName) {
    // A cardholder name allows letters, spaces, periods, dashes, and apostrophes.
    return /^[-a-zA-Z' .]{1,255}$/.test(cardholderName);
}
